/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { API } from 'middleware/api';

export const INVITE_FRIEND_REQUEST = 'INVITE_FRIEND_REQUEST';
export const INVITE_FRIEND_SUCCESS = 'INVITE_FRIEND_SUCCESS';
export const INVITE_FRIEND_FAILURE = 'INVITE_FRIEND_FAILURE';

/**
 * Create action object that is to invite friends.
 *
 * @param {string} token - JWT for request authentification.
 * @param {Object} invite - The invite object.
 * @param {string} invite.phone_number - Phone number of the person to invite in MSISDN format.
 *
 * @return {Object}
 */
export const inviteFriend = (token, invite) => ({
  [API]: {
    endpoint: `/user/friend/invite`,
    method: 'POST',
    body: invite,
    token,
    types: [
      INVITE_FRIEND_REQUEST,
      INVITE_FRIEND_SUCCESS,
      INVITE_FRIEND_FAILURE,
    ],
  },
});

export const INVITE_COLLEAGUE_REQUEST = 'INVITE_COLLEAGUE_REQUEST';
export const INVITE_COLLEAGUE_SUCCESS = 'INVITE_COLLEAGUE_SUCCESS';
export const INVITE_COLLEAGUE_FAILURE = 'INVITE_COLLEAGUE_FAILURE';

/**
 * Create action object that is to invite colleagues.
 *
 * @param {string} token - JWT for request authentification.
 * @param {Object} invite - The invite object.
 * @param {string} invite.phone_number - Phone number of the person to invite in MSISDN format.
 *
 * @return {Object}
 */
export const inviteColleague = (token, invite) => ({
  [API]: {
    endpoint: `/user/company/invite`,
    method: 'POST',
    body: invite,
    token,
    types: [
      INVITE_COLLEAGUE_REQUEST,
      INVITE_COLLEAGUE_SUCCESS,
      INVITE_COLLEAGUE_FAILURE,
    ],
  },
});
